module.exports = __webpack_public_path__ + "static/Dentures smile after-cf354c2748e0100fa4db0d548d5a8c1e.jpg";